import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Typography from 'brandComponents/Typography';

import {IPaymentCardInfoProps} from './IPaymentCardInfo';
import messages from './messages';
import {DeleteButton} from './Subcomponents';

import styles from './PaymentCardInfo.module.scss';

const PaymentCardInfo = ({classNames, paymentCard, allowDelete = true, paymentInstrumentId}: IPaymentCardInfoProps) => {
	const intl = useIntl();

	return (
		paymentCard && (
			<div className={cn('payment-card-info', styles['payment-card-info'], classNames)}>
				<Typography variant="span" classNames="payment-card-info__title">{intl.formatMessage(messages.creditCard)}</Typography>
				<Typography variant="span">{paymentCard.getHolder()}</Typography>
				<Typography variant="span">
					{paymentCard.getCardType()} {paymentCard.getMaskedNumber()}
				</Typography>
				<Typography variant="span">
					{intl.formatMessage(messages.expires)} {paymentCard.getExpirationMonth()}/
					{paymentCard.getExpirationYear()}
				</Typography>
				{allowDelete && (
					<PaymentCardInfo.DeleteButton
						paymentInstrumentId={paymentInstrumentId}
						classNames={styles['payment-card-info__ctas']}
						variant="primary"
					/>
				)}
			</div>
		)
	);
};

PaymentCardInfo.DeleteButton = DeleteButton;

export default PaymentCardInfo;
